export default "{\n    \"label\": \"Monto pendiente: {{amount}}\"\n}\n"